// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1722":"55dc6f94","5538":"ee17ab49","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};